import React from "react";
import { Helmet } from "react-helmet-async";
// import SectionTitle from "../../elements/section-title/SectionTitle";
import FaqData from "../../data/faq/FaqData.json";
import SEO from "../../common/SEO";
import ColorSwitcher from "../../elements/switcher/ColorSwitcher";
import HeaderOne from "../../common/header/HeaderOne";
import BreadCrumbOne from "../../elements/breadcrumb/BreadCrumbOne";
import CtaLayoutOne from "../cta/CtaLayoutOne";
import FooterOne from "../../common/footer/FooterOne";
import seoData from "../../seoData/FaqOne.json"

const allData = FaqData;

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": allData.map((data) => ({
    "@type": "Question",
    "name": data.title,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": data.body,
    },
  })),
};

const FaqOne = () => {
  return (
    <>
      <SEO {...seoData} />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne title="Faqs" page="Faqs" />

        <div className="section section-padding-equal bg-color-light faq-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 col-xl-4">
                {/* <SectionTitle
                  subtitle="Pricing Plan"
                  title="Frequently asked questions"
                  description="Aenean hendrerit laoreet vehicula. Nullam convallis augue at enim gravida pellentesque."
                  textAlignment="heading-left"
                  textColor=""
                /> */}
              </div>
              <div className="col-lg-7 col-xl-8">
                <div className="faq-plain-list">
                  {allData.map((data) => (
                    <div className="faq-plain-item mb--40" key={data.id}>
                      <h5 className="title">
                        <span>{`${data.id}. `}</span>
                        {data.title}
                      </h5>
                      <p>{data.body}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <ul className="shape-group-6 list-unstyled">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-7.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/line-4.png"}
                alt="line"
              />
            </li>
            <li className="shape shape-4 d-none d-lg-block">
              <img
                src={process.env.PUBLIC_URL + "/images/others/poses-lady.png"}
                alt="Poses"
              />
            </li>
          </ul>
        </div>

        <CtaLayoutOne />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default FaqOne;
